module.exports = __webpack_public_path__ + "img/Truppführer_E.e6ee83bd.svg";